import { Helmet } from 'react-helmet';

const AppScriptHeader = () => (
  <Helmet>
    <script src="//www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1" />
  </Helmet>
);

export default AppScriptHeader;
